import React, {useState} from 'react'
import { Navbar, Nav, Container, Row, Col } from 'react-bootstrap';
import userimage from './Images/user.png';
import logo from './Images/logo.png';
import { Link, useNavigate } from 'react-router-dom';

const TopNav = ({isLoggedIn, setIsJoinModalVisible, setIsLoginModalVisible, showDropdownPage, setShowDropdownPage, currentUser}) => {
    const navigate = useNavigate();

    const[text, setText] = useState('')

    const handleTextChange = (event) => {
        setText(event.target.value)
    }
    const search = (event) => {
        navigate('/search', {state:{text: text}});
        event.preventDefault()
      }
  return (
    <Navbar bg="" expand="lg" className="navbar feed-navbar">
        <Container fluid className="header">
            <Navbar.Brand href="#" className="logo"><img src={logo} alt="Cuisn Logo" className="logo"></img></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" className="toggle-button" onClick={() => {if (window.innerWidth <= 991) {setShowDropdownPage(!showDropdownPage)}}}/>
            <Navbar.Collapse id="basic-navbar-nav" className='basic-navbar-nav'>
                <div className='mr-auto'>
                    <div className='header-input-inner-div'>
                        <form onSubmit={search}>
                            <Row>
                                <Col xs={12} sm={12} md={9} lg={9}>
                                    <input placeholder='Tacos, Chef Lanez, Bistros, Culinary School, Utensils' className='header-input header-type-input top-nav-input' value={text} onChange={handleTextChange}></input>
                                </Col>
                                <Col xs={12} sm={12} md={3} lg={3}>
                                    <button className='header-search-button nav-search-button' type='submit' name='submit'>Search</button>
                                </Col>
                            </Row>
                        </form>
                    </div>
                </div>
                <Nav className="ms-auto">
                    {!isLoggedIn ? 
                        <div>
                            <button className="nav-links community create mobile-fix-navbar-create" onClick={() => {setIsLoginModalVisible(true)}}>Log In</button>
                            <button className="nav-links community create waitlist home-signup" onClick={() => {setIsJoinModalVisible(true)}}>Sign Up</button>
                        </div> : 
                        <div>
                            <Link to='/profile'>{(currentUser.image === '') ? <img src={userimage} alt=''className='feed-card-user-image'></img> : <img src={currentUser.image} alt=''className='feed-card-user-image'></img>}</Link>
                        </div>
                    }
                </Nav>
            </Navbar.Collapse>
        </Container>
    </Navbar>
  )
}

export default TopNav